var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle_success_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 26967",
    fill: "currentColor",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39243",
    clipPath: "url(#circle_success_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17382",
    d: "M16 3A13 13 0 113 16 13.015 13.015 0 0116 3m0-3a16 16 0 1016 16A16 16 0 0016 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17383",
    d: "M13.527 21.5a1.5 1.5 0 01-.968-.354l-3.305-2.792a1.5 1.5 0 111.937-2.292l2.267 1.916 7.276-7.055a1.5 1.5 0 012.088 2.154l-8.251 8a1.494 1.494 0 01-1.044.423"
  }))));
}
export default SvgCircleSuccess;